import { NoResults } from "lib/@components/no-results/no-results"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Case, CaseElse, Switch } from "lib/@components/switch"

/**
 * The left-hand list's empty state. Matches the progress line above it: a regime with no
 * schedules says so, rather than claiming every schedule is assigned.
 */
export function NothingLeftToAssign() {
    const { searching, board } = useBoundContext()
    return (
        // Sized for the left-hand pane rather than a whole page
        <NoResults width={140} mt={3}>
            <Switch value={emptyReason()}>
                <Case value="searching">No unassigned schedules match your search</Case>
                <Case value="no-schedules">This regime has no schedules</Case>
                <CaseElse>Every schedule in this regime is assigned directly</CaseElse>
            </Switch>
        </NoResults>
    )

    function emptyReason() {
        if (searching) return "searching"
        if (!board?.progress?.totalSchedules) return "no-schedules"
        return "all-assigned"
    }
}
